import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind class merger — used by every shadcn-style component. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

const KIND_ACRONYMS = new Set([
  'spf', 'dkim', 'dmarc', 'bimi', 'tls', 'rpt', 'mta', 'sts', 'dnsbl', 'dns', 'vmc', 'ip', 'mx', 'ptr', 'rua', 'arc', 'dane', 'dnssec',
]);

/**
 * Turn an alert `kind` slug (e.g. `dmarc_policy_weak`, `spf_permerror`) into a
 * readable title (`DMARC Policy Weak`, `SPF PermError`). Acronyms are
 * upper-cased; everything else is title-cased.
 */
export function humanizeKind(kind: string): string {
  return kind
    .split(/[_\s]+/)
    .map((w) => {
      const lw = w.toLowerCase();
      if (KIND_ACRONYMS.has(lw)) return lw.toUpperCase();
      if (lw === 'permerror') return 'PermError';
      return w.charAt(0).toUpperCase() + w.slice(1);
    })
    .join(' ');
}
